<template>
  <div class="notexpired-box">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, i) in state.list"
        :key="i + '-list'"
        :value="null"
        :border="false"
      >
        <template #value>
           <img class="coupon-action" @click="onCancel(item)" src="@/assets/trade/aiqu_reset1.png" alt="">
          <!-- <span class="coupon-action" @click="onCancel(item)">取消</span> -->
          <img
            class="orderTips"
            src="../../../assets/personal/ico_dscountorder.png"
            alt=""
            v-if="item.dscountorder == 1"
          />
          <div class="game-div" v-if="item.is_split == 0">
            <div id="recycle-info">
              <h3><span>¥</span>{{ item.coupon_money }}</h3>
              <p>满{{ item.pay_money }}元使用</p>
            </div>

            <div class="coupon-item">
              <p>{{ item.coupon_name }}</p>
              <p>适用于{{ item.gamename }}</p>
             <p>有效期至 {{ item.end_time.slice(0, 16)  }}</p>
            </div>
          </div>

          <!-- 可拆分优惠券 -->
          <div class="game-div" v-else-if="item.is_split === 1">
            <div id="recycle-info">
              <p class="split">余额</p>
              <h3><span>¥</span>{{ item.coupon_money }}</h3>
            </div>

            <div class="coupon-item">
              <p>
                <span>{{ item.coupon_name }}</span>
                <span>（可拆分使用）</span>
                <img
                  src="../../../assets/personal/yz_wd_ico_question.png"
                  alt=""
                  @click="openTips()"
                />
              </p>
              <p>适用于{{ item.gamename }}</p>
              <p>有效期至 {{ item.end_time.slice(0, 16)  }}</p>
            </div>
          </div>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import {
  reactive,
  onBeforeMount,
  onMounted,
  onUnmounted,
  onDeactivated,
  onActivated,
} from "vue";
import { Dialog, Toast } from "vant";
import { mycoupons } from "@/api/user";
import { enablecoupon } from "@/api/coupon";
import { useStore } from "vuex";
import { setToken } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import bus from "@/utils/bus";
export default {
  name: "deleted",
  setup() {
    const store = useStore();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    // 加载数据
    onBeforeMount(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
        store.dispatch("getInfo");
      }
    });
    onMounted(() => {
      // onLoad()
    });
    var pagecode = 1;
    const onLoad = async () => {
      var data = {
        status: -1,
        pagecode: pagecode,
        uid: getQueryString("uid"),
      };
      await mycoupons(data).then((response) => {
        if (response.data.code == 1) {
          if (pagecode > response.data.data.total_page) {
            state.finished = true;
            return;
          }
          state.list = state.list.concat(response.data.data.lists);
          var obj = {};
          state.list = state.list.reduce(function (item, next) {
            obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
            return item;
          }, []);
          pagecode++;
        } else {
          state.finished = true;
        }
      });
      state.loading = false;
    };
    let needRefresh = false;
    onActivated(() => {
      // 仅在被其他 tab 标记需要刷新时才清空重载；
      // 普通切回保留 keep-alive 缓存的列表与 finished 状态，
      // 否则会丢失“没有更多了”或把已加载的列表变空。
      if (needRefresh) {
        needRefresh = false;
        pagecode = 1;
        state.list = [];
        state.finished = false;
        // 置 loading=true 并主动加载第一页；加载完 loading 由 true→false 的变化
        // 会让 van-list 继续检测、自动翻页，避免停在空列表/只有一页。
        state.loading = true;
        onLoad();
      }
    });
    onDeactivated(() => {
      // 避免离开时正好在加载中导致返回后卡住，其余状态保留
      state.loading = false;
    });

    const openTips = () => {
      bus.emit("splitShow");
    };


    // 取消删除（恢复回未使用列表）
    const onCancel = (item) => {
      Dialog.confirm({
        title: "提示",
        message: "是否恢复当前优惠券",
      })
        .then(() => {
          enablecoupon({ uid: getQueryString("uid"), cid: item.cid }).then((res) => {
            if (res.data.code == 1) {
              state.list = state.list.filter((c) => c.id !== item.id);
              bus.emit("refreshNotExpired");
              Toast(res.data.msg || "操作成功");
            } else {
              Toast(res.data.msg || "操作失败");
            }
          });
        })
        .catch(() => {});
    };

    const markRefresh = () => {
      needRefresh = true;
    };

    bus.on("refreshDeleted", markRefresh);
    onUnmounted(() => {
      bus.off("refreshDeleted", markRefresh);
    });

    return {
      state,
      onLoad,
      openTips,
      onCancel,
    };
  },
};
</script>

<style scoped="scoped">
.notexpired-box {
  height: 93vh;
  background-color: #f7f8fa;
  overflow: auto;
  padding-bottom: 200px;
}

.van-cell {
  overflow: initial;
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  color: var(--van-cell-text-color);
  font-size: var(--van-cell-font-size);
  line-height: var(--van-cell-line-height);
  background: #f7f8fa;
  padding: 10px 32px;
}

.van-cell:deep(.van-cell__value) {
  overflow: initial;
}

.orderTips {
  width: 64px;
  height: 30px;
  position: absolute;
  left: -6px;
  top: 13px;
}
.coupon-action  {
  position: absolute;
  right: 24px;
  top: 36px;
  width: 36px;
  height: 36px;
  padding: 4px;
  opacity: 0.65;
}
/* .coupon-action {
  position: absolute;
  right: 44px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  padding: 6px 20px;
  font-size: 22px;
  color: #999999;
  background-color: rgba(255, 255, 255, 0.85);
  border: 1px solid #dddddd;
  border-radius: 100px;
} */

.game-div {
  display: flex;
  margin-top: 10px;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
  height: 160px;
  width: 686px;
  background: url(../../../assets/coupon/yz_wdyhq_bj2.png) no-repeat center top;
  background-size: 100% 100%;
}

.game-div img {
  width: 120px;
  height: 120px;
}

#recycle-info {
  width: 176px;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
#recycle-info .split {
  font-size: 24px;
}

#recycle-info h3 {
  font-size: 40px;
  color: #999999;
  margin-top: 10px;
}

#recycle-info h3 span {
  font-size: 20px;
  color: #999999;
  margin-top: 10px;
}

#recycle-info p {
  font-size: 16px;
  color: #999999;
}

.coupon-item {
  margin-left: 35px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.coupon-item p {
  font-size: 20px;
  color: #707070;
  line-height: 1.8;
}

.coupon-item p:nth-of-type(1) {
  font-size: 28px;
  color: #999999;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.coupon-item p:nth-of-type(1) span:nth-of-type(1) {
  font-size: 28px;
  max-width: 252px;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.coupon-item p:nth-of-type(1) span {
  font-size: 20px;
}

.coupon-item p:nth-of-type(1) img {
  width: 24px;
  height: 24px;
  z-index: 99;
}
</style>
